import React, { useMemo } from 'react'
import { Cell, Row } from '../Elements'
import { IColumn } from './types'

type UseBody = {
  rows: Array<any>
  columns: Array<IColumn>
}

export const useBody = ({ columns, rows }: UseBody) => {
  return useMemo(() => {
    return rows.map((row, index) => {
      const id = row?.id || index
      const cells = columns.map((column, idx) => (
        <Cell
          key={`${id}_${column.field}${idx}${index}`}
          className={row?.['className'] || ''}
        >
          {row[column.field]}
        </Cell>
      ))

      return (
        <React.Fragment key={id + index}>
          <Row isOdd={index % 2 === 0}>{cells}</Row>
        </React.Fragment>
      )
    })
  }, [columns, rows])
}
